import { Box, ColorOptions, convertHexToRGBA, Image, ModBox, Spacer, Text, useWindowDimensions } from '@jfs/ui-new'
import { colors } from '../../util/colors'
import usePadding from '../../util/usePadding'
import { isMobileWidth } from '../../util/util'

const ImageDotted = require('../../assets/images/dotted-background.png')

export const MultiLanguage = ({ hide = false }) => {
  if (hide) {
    return null
  }
  const viewPortWidth = useWindowDimensions()
  const isMobile = isMobileWidth(viewPortWidth)
  const resPadding = usePadding()
  const bgCircleSize = 540
  const outlineCircleSize = 600
  return (
    <Box borderWidth={1} bg={colors.JIO_PRIMARY_ALPHA as ColorOptions} align={'center'} zIndex={-1}>
      <Spacer direction={'vertical'} size={isMobile ? 24 : 72} />
      <Box ph={resPadding}>
        <Text
          title={'Local Sound for Local Payments'}
          fontSize={isMobile ? 24 : 40}
          color={'WHITE'}
          fontFamily={'jiotype-black'}
        />
      </Box>
      <Spacer direction={'vertical'} size={isMobile ? 16 : 24} />
      <Box w={isMobile ? '80%' : 360} ph={16}>
        <Text
          title={'Get voice alerts in your own Regional Language!'}
          textAlign={'center'}
          fontFamily={'jiotype-bold'}
          fontSize={isMobile ? 16 : 24}
          color={'#788BC6' as ColorOptions}
        />
      </Box>
      <Spacer direction={'vertical'} size={isMobile ? 32 : 76} />
      <Box ph={isMobile ? resPadding : undefined} width={isMobile ? '100%' : 716} height={isMobile ? 360 : 520}>
        <Image
          source={require('../../assets/images/multiLingualcollage.png')}
          width={isMobile ? '100%' : 716}
          height={isMobile ? 360 : 520}
          resizeMode={'contain'}
        />
      </Box>
      <Box position={'absolute'} top={0} right={0} flexDirection={'row'}>
        <Image resizeMode="contain" source={ImageDotted} width={isMobile ? 50 : 120} height={isMobile ? 50 : 120} />
        <Spacer direction="horizontal" size={isMobile ? 4 : 8} />
        <Image resizeMode="contain" source={ImageDotted} width={isMobile ? 50 : 120} height={isMobile ? 50 : 120} />
      </Box>
      <Box position={'absolute'} bottom={isMobile ? -25 : -50} left={isMobile ? 8 : 24}>
        <Image resizeMode="contain" source={ImageDotted} width={isMobile ? 50 : 120} height={isMobile ? 50 : 120} />
      </Box>
      <ModBox
        position={'absolute'}
        show={!isMobile}
        top={-140}
        left={-180}
        w={bgCircleSize}
        h={bgCircleSize}
        bg={convertHexToRGBA('#788BC6', 10) as ColorOptions}
        borderRadius={bgCircleSize}
      />
      <ModBox
        position={'absolute'}
        show={!isMobile}
        top={-250}
        left={-140}
        w={outlineCircleSize}
        h={outlineCircleSize}
        borderWidth={0.5}
        borderColor={'#F6F7FA' as ColorOptions}
        borderRadius={outlineCircleSize}
      />
      <ModBox
        position={'absolute'}
        show={!isMobile}
        bottom={-140}
        right={-60}
        w={240}
        h={240}
        bg={convertHexToRGBA('#788BC6', 10) as ColorOptions}
        borderRadius={200}
      />
      <ModBox
        position={'absolute'}
        show={!isMobile}
        bottom={-200}
        right={-220}
        w={400}
        h={400}
        borderWidth={0.5}
        borderColor={'#F6F7FA' as ColorOptions}
        borderRadius={200}
      />
    </Box>
  )
}
